import { render, staticRenderFns } from "./WorkspaceSharedUser.vue?vue&type=template&id=7551f56a"
import script from "./WorkspaceSharedUser.vue?vue&type=script&lang=js"
export * from "./WorkspaceSharedUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports